import "./module/userAgentChecker.js"
import "./module/plugin.js"

import Swiper from 'swiper/bundle';
var swiper = new Swiper('.mvSlider', {
  effect: 'fade',
  speed: 4500,
  loop: true,
  simulateTouch: false,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
});

import ScrollMagic from 'scrollmagic';
class ScrollFade {
  constructor() {
      this.ANIMATION_CLASS = 'is_animation';

      let $section = document.querySelectorAll('.scroll:not(.is_animation)');
      if($section.length === null) {
          return;
      }
      let controller = new ScrollMagic.Controller();
      for(let i = 0; i < $section.length; i++) {
          let scene = new ScrollMagic.Scene({
              triggerElement: $section[i],
              triggerHook: 'onEnter',
              reverse: false,
              offset: 100
          })
              .addTo(controller);
          scene.on('enter', ()=>{
              $section[i].classList.add(this.ANIMATION_CLASS);
          });
          scene.on('end', ()=>{
              scene.destroy(true);
          });
      }
  }
}

new ScrollFade();

import Rellax from 'rellax';
var rellax = new Rellax('.parallax', {
  center:true
});

(function(d) {
    var config = {
      kitId: 'fwf8msz',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);
